import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css'; // 지금 가지고 있는 App.css 재사용

export default function Home() {
  const navigate = useNavigate();
  return (
    <div className="app-container">
      <h1>금천일자리주식회사 내부망 ERP 첫 화면입니다.</h1>
      <div className="button-group">
        <button className="app-button" onClick={() => navigate('/login')}>로그인</button>
        <button className="app-button signup" onClick={() => navigate('/signup')}>회원가입</button>
      </div>
    </div>
  );
}
